import { TextField } from "@mui/material";
import { useContext, useState } from "react";
import useCheckStudentHomework from "../../../Hooks/useCheckStudentHomework";
import { AuthContext } from "../../../Context/AuthContext";

export default function RemarkHomework({ editData }) {
  const { t } = useContext(AuthContext);

  return (
    <TextField
      fullWidth
      size="small"
      multiline
      className="text-field"
      placeholder={t("thead_reason")}
      value={editData?.remark || ""}
      sx={{
        "& .MuiInputBase-input": {
          textAlign: "center",
          minWidth: 120,
        },
      }}
    />
  );
}
